const config = envConfig => ({
    headers: {
      "Cache-Control": "no-cached, no-store",
      Pragma: "no-cache",
      Expires: "-1",
    },
    httpConfig: {
      withCredentials: true,
    },
  });
  
  export default config;
  